module.exports = __webpack_public_path__ + "static/img/Bachelor_010800.b2439ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010800.jpg
// module id = 252
// module chunks = 0